import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Video: {
    id: 'Video',
    defaultMessage: 'Video',
  },
  VideoURL: {
    id: 'Video URL',
    defaultMessage: 'Video URL',
  },
  Preview_image: {
    id: 'Preview Image URL',
    defaultMessage: 'Preview Image URL',
  },
  Alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  Title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  TitleDescription: {
    id: 'BonnVideoTitleDescription',
    defaultMessage: 'Shown below the video and used to label the player.',
  },
  Copyright: {
    id: 'Video credit',
    defaultMessage: 'Video credit',
  },
});
export const VideoBlockSchema = (props) => ({
  title: props.intl.formatMessage(messages.Video),
  block: 'Video',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['url', 'preview_image', 'title', 'copyright'],
    },
  ],

  properties: {
    url: {
      title: props.intl.formatMessage(messages.VideoURL),
      widget: 'url',
    },
    preview_image: {
      title: props.intl.formatMessage(messages.Preview_image),
      widget: 'url',
    },
    title: {
      title: props.intl.formatMessage(messages.Title),
      description: props.intl.formatMessage(messages.TitleDescription),
    },
    copyright: {
      title: props.intl.formatMessage(messages.Copyright),
    },
    align: {
      title: props.intl.formatMessage(messages.Alignment),
      widget: 'align',
    },
  },
  required: [],
});

export default VideoBlockSchema;
